// extracted by mini-css-extract-plugin
export var dateLabel = "_3l-0";
export var dateLabelError = "_3l-1";
export var fullWidth = "_3l-2";
export var smaller = "_3l-3";